import React, { Component } from 'react'
import styled from 'styled-components'
import Modal from '../Modal'
import { pxToRem } from '../../utils'
import {
  Input,
  Select,
  Button,
  TextArea,
  InputMaskDate,
  InputMaskDateTime,
  InputError,
  FormControl,
  InputFile
} from '../Form'
import { connect } from 'react-redux'
import { color } from '../../utils'
import { productMapActions, inventoryActions } from '../../actions'
import CurrencyFormat from 'react-currency-format'
import * as API from '../../api'
import { DebounceInput } from 'react-debounce-input'
import statusSuccessIcon from '../../assets/icons/status-success.svg'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''

const InvoiceButton = styled(Button)`
  width: 20%;
  margin-top: 20px;
`

const WrapperSelect = styled(FormControl)`
  margin-top: 20px;
  width: 100%;
  display: inline-block;
  color: ${color.secondary};
  padding: 0;
  label {
    font-size: ${pxToRem(16)};
    height: ${pxToRem(50)};
    line-height: ${pxToRem(50)};
  }
`

const WrapperInputWithError = styled(FormControl)`
  padding: 0;
  width: ${props => props.width};
  margin: ${props => props.margin};
`

const WrapperRow = styled.div`
  display: flex;
  width: 100%;
`

const FileInputContent = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
  width: 100%;
  p {
    padding: auto 0;
    margin: 10px;
  }
`

const Line = styled.hr`
  margin-top: 20px;
`

const SaveButton = styled(InvoiceButton)`
  margin-left: 2.5%;
  background-color: ${color.primary};
  border: 0;
`

const CancelButton = styled(InvoiceButton)`
  margin-left: 2.5%;
  background-color: #e84d4d;
  border: 0;
`

const InvoiceLink = styled.a`
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  cursor: pointer;
  color: ${color.secondary};
`

const WrapperIcon = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;
  background: ${color.success};

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: ${pxToRem('15px')}
  }
`

class InventoryInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      inventory: {},
      open: false,
      submitted: false,
      currentAreaId: null,
      currentUserId: null,
      productError: null,
      amountError: null,
      batchError: null,
      expirationDateError: null,
      manufacturingDateError: null,
      amountPackageError: null,
      transactionDateError: null
    }
  }

  componentDidMount() {
    this.props.fetchProductList(this.props.currentAreaId)
  }

  componentWillReceiveProps(props) {
    if(this.props.currentAreaId !== props.currentAreaId) {
      this.props.fetchProductList(props.currentAreaId)
    }
    this.setState(state => ({
      inventory: props.inventoryItem,
      currentAreaId: props.currentAreaId,
      currentUserId: props.currentUserId,
      open: props.open,
      productCabinets: '',
      productError: null,
      amountError: null,
      batchError: null,
      expirationDateError: null,
      manufacturingDateError: null,
      amountPackageError: null,
      transactionDateError: null
    }))

    this.setDefaultValue()
  }

  setDefaultValue() {
    this.setState(state => ({
      inventory: {
        amount: '',
        amountPackage: '',
        minimum_stock: '',
        transaction_date: new Date().toLocaleString('pt-BR', { minimumFractionDigits: 5 }),
        areaId: this.state.currentAreaId,
        userId: this.state.currentUserId,
        ...state.inventory
      }
    }))
  }

  // retorna a data do dia atual
  createAt = () => {
    return new Date().toLocaleDateString('pt-BR')
  }

  closeModal = () => {
    this.props.closeMethod()
  }

  // valida se o metodo é um CREATE ou UPDATE
  checkMethod = () => {
    return this.props.method === 'create'
  }

  handleProduct = async product => {
    await this.setState(state => ({
      productError: null,
      inventory: {
        ...state.inventory,
        product_measure_description: product.measure,
        productId: product.value
      },
      productCabinets: product.cabinets
    }))
    this.getBatch()
  }

  handleObservation = observation => {
    this.setState(state => ({
      inventory: {
        ...state.inventory,
        observation
      }
    }))
  }

  handleBatch = async batch => {
    if (this.checkMethod()) {
      await this.setState(state => ({
        batchError: null,
        inventory: {
          ...state.inventory,
          batch
        }
      }))
      this.getBatch()
    }
  }

  getBatch = () => {
    const { areaId, productId, batch } = this.state.inventory
    
    API.inventory.getBatch(productId, areaId, batch)
      .then(response => {
        const foundedBatch = ((response || {}).data || {}).item
        if (!!foundedBatch) {
          const foundedBatch = response.data.item
          this.setState(state => ({
            ...state,
            inventory: {
              ...state.inventory,
              manufacturing_date: foundedBatch.manufacturing_date,
              expiration_date: foundedBatch.expiration_date,
              minimum_stock: foundedBatch.minimum_stock,
            }
          }))
        } else {
          this.setState(state => ({
            ...state,
            inventory: {
              ...state.inventory,
              manufacturing_date: null,
              expiration_date: null,
              minimum_stock: null,
            }
          }))
        }
      })
  }

  handleManufacturingDate = manufacturing_date => {
    this.setState(state => ({
      manufacturingDateError: null,
      inventory: {
        ...state.inventory,
        manufacturing_date
      }
    }))
  }

  handleExpirationDate = expiration_date => {
    this.setState(state => ({
      expirationDateError: null,
      inventory: {
        ...state.inventory,
        expiration_date
      }
    }))
  }

  handleMinimumStock = (minimum_stock) => {
    this.setState(state => ({
      inventory: {
        ...state.inventory,
        minimum_stock
      }
    }))
  }

  handleAmount = amount => {
    const totalOfInput = amount * this.state.inventory.amountPackage || amount
    if (this.checkMethod()) {
      this.setState(state => ({
        amountError: null,
        inventory: {
          ...state.inventory,
          amount,
          totalOfInput
        }
      }))
    }
  }

  handleAmountPackage = amountPackage => {
    if (this.checkMethod()) {
      const totalOfInput = amountPackage * this.state.inventory.amount || this.state.inventory.totalOfInput
      this.setState(state => ({
        amountError: null,
        inventory: {
          ...state.inventory,
          amountPackage,
          totalOfInput
        }
      }))
    }
  }

  handleTransactionDate = transaction_date => {
    if (this.checkMethod()) {
      this.setState(state => ({
        inventory: {
          ...state.inventory,
          transaction_date
        }
      }))
    }
  }

  productFullName = product => {
    let provider =
      product && product.provider && product.provider !== '---'
        ? ' - (' + product.provider + ')'
        : ''
    return product.name + provider
  }

  handleSubmit = event => {
    this.checkMethod() ? this.addInventoryInput(event) : this.editInventoryInput(event)
  }

  addInventoryInput = event => {
    event.preventDefault()

    this.setState({ submitted: true })

    const { inventory } = this.state

    const batchValid = this.batchValid()
    const productValid = this.validProduct()
    const amountValid = this.validAmount()
    const amountPackageValid = this.validAmountPackage()
    const expirationDateValid = this.validExpirationDate()
    const manufacturingDateValid = this.validManufacturingDate()
    const transactionDateValid = this.validTransactionDate()

    if (
      this.checkMethod() 
      && batchValid 
      && productValid 
      && amountValid 
      && amountPackageValid 
      && expirationDateValid 
      && manufacturingDateValid 
      && transactionDateValid
    ) {
      this.props.addInventoryInput(inventory, this.props.searchText, this.props.pagination)
      this.closeModal()
    }
  }

  editInventoryInput = event => {
    event.preventDefault()
    this.setState({ submitted: true })

    const { inventory } = this.state

    const expirationDateValid = this.validExpirationDate()
    const manufacturingDateValid = this.validManufacturingDate()

    if (
      !this.checkMethod() &&
      expirationDateValid &&
      manufacturingDateValid
    ) {
      this.props.editInventoryInput(inventory, this.props.searchText, this.props.pagination)
      this.closeModal()
    }
  }

  batchValid = () => {
    const { batch } = this.state.inventory

    if (!batch) {
      this.setState(state => ({
        batchError: 'Lote é obrigatório'
      }))
      return false
    }
    this.setState(state => ({
      batchError: null
    }))
    return true
  }

  validProduct = () => {
    const { productId } = this.state.inventory

    if (!productId) {
      this.setState(state => ({
        productError: 'Produto é obrigatório'
      }))
      return false
    }
    this.setState(state => ({
      productError: null
    }))
    return true
  }

  validAmount = () => {
    const { amount } = this.state.inventory

    if (!amount) {
      this.setState(state => ({
        amountError: 'Quantidade é obrigatório'
      }))
      return false
    }

    if (amount <= 0) {
      this.setState(state => ({
        amountError: 'Quantidade inválida'
      }))
      return false
    }

    this.setState(state => ({
      amountError: null
    }))
    return true
  }

  validManufacturingDate = () => {
    const { manufacturing_date } = this.state.inventory
    if (manufacturing_date) {
      const day = manufacturing_date[0] + manufacturing_date[1]
      const month = manufacturing_date[3] + manufacturing_date[4]
      const year = manufacturing_date[6] + manufacturing_date[7] + manufacturing_date[8] + manufacturing_date[9]
      if (
        this.validDay(day, 'manufacturingDateError') && 
        this.validMonth(month, 'manufacturingDateError') && 
        this.validFuture(day, month, year, 'manufacturingDateError')
      ) {
        return true
      }
      return false
    }
    return true
  }

  isExpiresBeforeManufacture = () => {
    const manufacturingDate = this.state.inventory.manufacturing_date
    const expirationDate = this.state.inventory.expiration_date

    if (!!manufacturingDate && !!expirationDate) {
      const manufactureDay = manufacturingDate[0] + manufacturingDate[1]
      const manufactureMonth = manufacturingDate[3] + manufacturingDate[4]
      const manufactureYear = manufacturingDate[6] + manufacturingDate[7] + manufacturingDate[8] + manufacturingDate[9]
      
      const expirationDay = expirationDate[0] + expirationDate[1]
      const expirationMonth = expirationDate[3] + expirationDate[4]
      const expirationYear = expirationDate[6] + expirationDate[7] + expirationDate[8] + expirationDate[9]
      
      if (
        manufactureYear > expirationYear ||
        (manufactureMonth > expirationMonth && manufactureYear >= expirationYear) ||
        (manufactureDay > expirationDay && manufactureMonth >= expirationMonth && manufactureYear >= expirationYear)
      ) {
        this.setState(state => ({
          expirationDateError: 'Validade menor que a fabricação'
        }))
        return false
      }
    } 
    this.setState(state => ({
      expirationDateError: null
    }))
    return true
  }

  validExpirationDate = () => {
    const { expiration_date } = this.state.inventory
    if (expiration_date) {
      const day = expiration_date[0] + expiration_date[1]
      const month = expiration_date[3] + expiration_date[4]
      if (
        this.validDay(day, 'expirationDateError') && 
        this.validMonth(month, 'expirationDateError') &&
        this.isExpiresBeforeManufacture()
      ) {
        return true
      }
      return false
    }
    return true
  }

  validTransactionDate = () => {
    const fieldError = 'transactionDateError'
    const { transaction_date } = this.state.inventory
    if (transaction_date) {
      const day = transaction_date[0] + transaction_date[1]
      const month = transaction_date[3] + transaction_date[4]
      const year = transaction_date[6] + transaction_date[7] + transaction_date[8] + transaction_date[9]
      const hour = transaction_date[11] + transaction_date[12]
      const minutes = transaction_date[14] + transaction_date[15]

      return (
        this.validDay(day, fieldError) 
        && this.validMonth(month, fieldError)
        && this.validTime(hour, minutes, fieldError)
        && this.validTimeFuture(year, month, day, hour, minutes, fieldError)
      )
    }
    return true
  }

  validDay = (day, fieldError) => {
    if (day > 31 || day < 1) {
      this.setState(state => ({
        [fieldError]: 'Data inválida'
      }))
      return false
    }
    this.setState(state => ({
      [fieldError]: null
    }))
    return true
  }

  validMonth = (month, fieldError) => {
    if (month > 12 || month < 1) {
      this.setState(state => ({
        [fieldError]: 'Data inválida'
      }))
      return false
    }
    this.setState(state => ({
      [fieldError]: null
    }))
    return true
  }

  validPast = (day, month, year, fieldError) => {
    const date = this.createAt()
    const currentDay = date[0] + date[1]
    const currentMonth = date[3] + date[4]
    const currentYear = date[6] + date[7] + date[8] + date[9]
    if (
      currentYear > year ||
      (currentMonth > month && currentYear > year) ||
      (currentDay > day && currentMonth >= month && currentYear >= year)
    ) {
      this.setState(state => ({
        [fieldError]: 'Digite uma data futura'
      }))
      return false
    }
    this.setState(state => ({
      [fieldError]: null
    }))
    return true
  }

  validFuture = (day, month, year, fieldError) => {
    const date = this.createAt()
    const currentDay = date[0] + date[1]
    const currentMonth = date[3] + date[4]
    const currentYear = date[6] + date[7] + date[8] + date[9]
    if (
      currentYear < year ||
      (currentMonth < month && currentYear < year) ||
      (currentDay < day && currentMonth <= month && currentYear <= year)
    ) {
      this.setState(state => ({
        [fieldError]: 'Data não deve ser futura'
      }))
      return false
    }
      this.setState(state => ({
        [fieldError]: null
      }))
      return true
  }

  validHour = (hour, fieldError) => {
    if (hour.includes('_') || hour > 24 || hour < 0) {
      this.setState(state => ({
        [fieldError]: 'Horas inválidas'
      }))
      return false
    }
    this.setState(state => ({
      [fieldError]: null
    }))
    return true
  }

  validMinutes = (minutes, fieldError) => {
    if (minutes.includes('_') || minutes > 59 || minutes < 0) {
      this.setState(state => ({
        [fieldError]: 'Minutos inválidos'
      }))
      return false
    }
    this.setState(state => ({
      [fieldError]: null
    }))
    return true
  }

  validTime = (hour, minutes, fieldError) => {
    return this.validHour(hour, fieldError) && this.validMinutes(minutes, fieldError)
  }

  validTimeFuture = (year, month, day, hour, minutes, fieldError) => {
    const input = new Date(year, month - 1, day, hour, minutes)
    const current = new Date()
    if (input <= current) {
      this.setState(state => ({
        [fieldError]: null
      }))
      return true
    }
    this.setState(state => ({
      [fieldError]: 'Data não deve ser futura'
    }))
    return false
  }

  validAmountPackage = () => {
    const { amountPackage } = this.state.inventory

    if (amountPackage < 0) {
      this.setState(state => ({
        amountPackageError: 'Quantidade inválida'
      }))
      return false
    }

    this.setState(state => ({
      amountPackageError: null
    }))
    return true
  }

  uploadFile = (event, callback) => {
    let file = event.target.files[0]
    let reader = new FileReader()

    reader.readAsDataURL(file)
    reader.onload = e => { callback(e.target.result, file.name) }
  }

  uploadInvoice = event => {
    this.uploadFile(event, (result, fileName) => {
      this.setState(state => ({
        inventory: {
          ...state.inventory,
          invoice: result,
          invoiceFileName: fileName
        }
      }))
    })
  }

  uploadCertificate = event => {
    this.uploadFile(event, (result, fileName) => {
      this.setState(state => ({
        inventory: {
          ...state.inventory,
          certificate: result,
          certificateFileName: fileName
        }
      }))
    })
  }

  openFile = url => {
    if (!!API_BASE_URL && !!url) {
      window.open(`${API_BASE_URL}${url}`, '_blank')
    }
  }

  isEditMode() {
    return this.props.method === 'edit'
  }

  readOnly() {
    if(this.isEditMode()) {
      return ''
    }
    return false
  }

  render() {
    const {
      name,
      open = false,
      size,
      title,
      method,
      loading = false,
      closeMethod,
      currentUser,
      currentArea,
      productList
    } = this.props

    const {
      createAt,
      closeModal,
      checkMethod,
      handleBatch,
      handleAmount,
      handleProduct,
      handleObservation,
      handleAmountPackage,
      handleExpirationDate,
      handleManufacturingDate,
      productFullName,
      handleSubmit,
      uploadInvoice,
      uploadCertificate,
      isEditMode,
      openFile,
      handleMinimumStock
    } = this

    const {
      inventory,
      submitted,
      batchError,
      productError,
      amountError,
      expirationDateError,
      manufacturingDateError,
      amountPackageError,
      transactionDateError,
      productCabinets
    } = this.state
    return (
      <Modal
        title={title}
        name={name}
        open={open}
        size={size}
        method={method}
        loading={loading}
        closeMethod={closeMethod}
      >
        <form onSubmit={handleSubmit} id={'form'}>
          <WrapperRow>
            {checkMethod() ? (
              <WrapperSelect>
                <Select
                  placeholder={'PRODUTO'}
                  onChange={event => {
                    handleProduct(event)
                  }}
                  options={productList.map(product => {
                    return {
                      label: productFullName(product),
                      value: product.id,
                      measure: product.measure,
                      cabinets: product.cabinets
                    }
                  })}
                />
                {submitted && productError && <InputError>{productError}</InputError>}
              </WrapperSelect>
            ) : (
              <Input
                readonly={this.readOnly()}
                checked={isEditMode}
                label={'PRODUTO'}
                value={productFullName(inventory) || ''}
                width={'100%'}
                autoFocus
                margin={'20px 0 0 0'}
              />
            )}
          </WrapperRow>
          <WrapperRow>
            <WrapperInputWithError width={'50%'} margin={'20px 0 0 0'}>
              <DebounceInput
                debounceTimeout={400}
                element={Input}
                label={'LOTE / IDENTIFICAÇÃO'}
                disabled={isEditMode}
                readonly={this.readOnly()}
                value={inventory.batch || ''}
                onChange={event => handleBatch(event.target.value)} 
              />
              {submitted && batchError && <InputError>{batchError}</InputError>}
            </WrapperInputWithError>
            <WrapperInputWithError width={'25%'} margin={'20px 0 0 5%'}>
              <InputMaskDate
                onChange={event => {
                  handleManufacturingDate(event.target.value)
                }}
                label={'FABRICAÇÃO'}
                type={'text'}
                value={inventory.manufacturing_date || ''}
              />
              {submitted && manufacturingDateError && <InputError>{manufacturingDateError}</InputError>}
            </WrapperInputWithError>
            <WrapperInputWithError width={'25%'} margin={'20px 0 0 5%'}>
              <InputMaskDate
                onChange={event => {
                  handleExpirationDate(event.target.value)
                }}
                label={'VALIDADE'}
                type={'text'}
                value={inventory.expiration_date || ''}
              />
              {submitted && expirationDateError && <InputError>{expirationDateError}</InputError>}
            </WrapperInputWithError>
          </WrapperRow>
          <WrapperRow>
            <WrapperInputWithError width={'25%'} margin={'20px 0 0 0'}>
              {this.checkMethod() ? 
                <CurrencyFormat
                  thousandSeparator={'.'}
                  decimalSeparator={false}
                  decimalScale={0}
                  allowNegative={false}
                  customInput={Input}
                  label={'QTD. EMBALAGEM'}
                  floatValue={inventory.amountPackage}
                  onValueChange={(values) => {
                    handleAmountPackage(values.floatValue)
                  }}
                  disabled={isEditMode}
                />
              :
                <CurrencyFormat
                  thousandSeparator={'.'}
                  decimalSeparator={false}
                  decimalScale={0}
                  allowNegative={false}
                  customInput={Input}
                  label={'QTD. EMBALAGEM'}
                  value={inventory.amount_package}
                  readonly={'readonly'}
                  disabled={isEditMode}
                />
              }
              {submitted && amountPackageError && <InputError>{amountPackageError}</InputError>}
            </WrapperInputWithError>
            <WrapperInputWithError width={'25%'} margin={'20px 0 0 5%'}>
              {this.checkMethod() ? 
                <CurrencyFormat
                  thousandSeparator={'.'}
                  decimalSeparator={','}
                  decimalScale={5}
                  allowNegative={false}
                  customInput={Input}
                  label={'QTD.'}
                  onValueChange={(values) => {
                    handleAmount(values.floatValue)
                  }}
                  floatValue={inventory.amount || ''}
                  readonly={this.readOnly()}
                  disabled={isEditMode}
                /> 
                : 
                <CurrencyFormat
                  thousandSeparator={'.'}
                  decimalSeparator={','}
                  decimalScale={5}
                  allowNegative={false}
                  customInput={Input}
                  label={'QTD.'}
                  value={(inventory.amount / inventory.amount_package) || inventory.amount}
                  readonly={'readonly'}
                  disabled={isEditMode}
                /> 
              }
              {submitted && amountError && <InputError>{amountError}</InputError>}
            </WrapperInputWithError>
            <Input
              disabled={isEditMode}
              label={'UN. MEDIDA'}
              display={'inline-block'}
              value={inventory.product_measure_description || ''}
              width={'10%'}
              margin={'20px 0 0 5%'}
              readonly={'readonly'}
            />
            <CurrencyFormat
              thousandSeparator={'.'}
              decimalSeparator={','}
              decimalScale={5}
              allowNegative={false}
              customInput={Input}
              width={'20%'}
              margin={'20px 0 0 5%'}
              label={'TOTAL DA ENTRADA'}
              value={this.checkMethod() ? (inventory.totalOfInput || '') : inventory.amount}
              readonly={'readonly'}
              disabled={isEditMode}
            />
            <CurrencyFormat
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={5}
              allowNegative={false}
              customInput={Input}
              width={'20%'}
              margin={'20px 0 0 5%'}
              label="ESTOQUE MÍNIMO"
              onValueChange={(values) => {
                handleMinimumStock(values.formattedValue)
              }}
              value={inventory.minimum_stock || ''}
            />
          </WrapperRow>
          <WrapperRow>
            <Input
              disabled={isEditMode}
              label={'ARMÁRIOS'}
              display={'inline-block'}
              value={this.checkMethod()? (productCabinets || '') : (inventory.cabinets)}
              width={'100%'}
              margin={'20px 0 0 0'}
              readonly={'readonly'}
            />
          </WrapperRow>

          {this.checkMethod() || inventory.invoice_url === '---' ? (
            <FileInputContent>
              <InputFile
                id={'invoiceInput'}
                type={'file'}
                width={'50%'}
                accept={'.pdf'}
                label="Escolha a nota fiscal"
                onChange={event => {
                  uploadInvoice(event)
                }}
              />
              <p>{this.state.inventory.invoiceFileName}</p>
            </FileInputContent>
          ) : (
            <InvoiceLink href="javascript:void(0)" onClick={e => openFile(inventory.invoice_url)}>
              <WrapperIcon>
                <img src={statusSuccessIcon} /> 
              </WrapperIcon>
              Visualizar Nota Fiscal
            </InvoiceLink>
          )}

          {this.checkMethod() || inventory.certificate_url === '---' ? (
            <FileInputContent>
              <InputFile
                id={'certificateInput'}
                type={'file'}
                width={'50%'}
                accept={'.pdf'}
                label="Escolha o certificado"
                onChange={event => {
                  uploadCertificate(event)
                }}
              />
              <p>{this.state.inventory.certificateFileName}</p>
            </FileInputContent>
          ) : (
            <InvoiceLink href="javascript:void(0)" onClick={e => openFile(inventory.certificate_url)}>
              <WrapperIcon>
                <img src={statusSuccessIcon} /> 
              </WrapperIcon>
              Visualizar Certificado
            </InvoiceLink>
          )}

          <TextArea
            value={inventory.observation === '---' ? '' : inventory.observation}
            onChange={event => {
              handleObservation(event.target.value)
            }}
            display={'inline-block'}
            margin={'20px 0 0 0'}
            label={'OBS.'}
          />

          <Line />
          <WrapperRow>
            <Input
              label={'RESPONSÁVEL'}
              display={'inline-block'}
              value={currentUser}
              width={'20%'}
              margin={'20px 0 0 0'}
              readonly={'readonly'}
              disabled={isEditMode}
            />

            <Input
              label={'ÁREA'}
              display={'inline-block'}
              value={currentArea}
              width={'20%'}
              margin={'20px 0 0 5%'}
              readonly={'readonly'}
              disabled={isEditMode}
            />
            <WrapperInputWithError width={'25%'} margin={'20px 0 0 5%'}>
              <InputMaskDateTime
                readonly={this.readOnly()}
                onChange={event => {
                  this.handleTransactionDate(event.target.value)
                }}
                label={'DATA ENTRADA'}
                type={'text'}
                value={inventory.transaction_date}
              />
              {submitted && transactionDateError && <InputError>{transactionDateError}</InputError>}
            </WrapperInputWithError>
            <CancelButton type={'button'} onClick={closeModal}>
              Cancelar
            </CancelButton>
            <SaveButton type={'submit'} form={'form'}>
              Salvar
            </SaveButton>
          </WrapperRow>
        </form>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.auth.userName,
  currentUserId: state.auth.userId,
  currentArea: state.auth.areaName,
  currentAreaId: state.auth.areaId,
  productList: state.productMap.items,
  searchText: state.search.searchText,
  pagination: state.inventory.pagination
})

const mapDispatchToProps = dispatch => {
  return {
    fetchProductList: areaId => {
      dispatch(productMapActions.fetchCollectionProductsByInventory(areaId))
    },
    addInventoryInput: (inventory, searchText, pagination) => {
      dispatch(inventoryActions.addInventoryInput(inventory, searchText, pagination))
    },
    editInventoryInput: (inventory, searchText, pagination) => {
      dispatch(inventoryActions.editInventoryInput(inventory, searchText, pagination))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryInput)



// WEBPACK FOOTER //
// ./src/components/Inventory/InventoryInputModal.js